<template>
    <div class="loading-component" :style="{ backgroundColor }">
        <div class="loading-component__content">
            <figure class="loading-component__icon">
                <loading-icon :type="type" :color="color" />
            </figure>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import appThemes from '@/data/app-themes';
import LoadingIcon from './loading-icon';

const LIGHT_THEME = {
    COLOR: appThemes.light.app.color,
    BACKGROUND_COLOR: appThemes.light.app.backgroundColor,
};

const DARK_THEME = {
    COLOR: appThemes.dark.app.color,
    BACKGROUND_COLOR: appThemes.dark.app.backgroundColor,
};

export default {
    name: 'loading-component',
    components: { LoadingIcon },

    props: {
        type: {
            type: String,
            default: 'spinner',
        },

        // pass "light" or "dark" to force a color mode
        // ... otherwise the colors with automatically change based on the app theme
        mode: {
            type: String,
            default: '',
        },
    },

    computed: {
        ...mapState({
            appTheme: state => state.page.appTheme,
        }),

        color() {
            switch (true) {
                case !!this.mode:
                    return this.mode === 'light' ? LIGHT_THEME.COLOR : DARK_THEME.COLOR;

                case this.appTheme === 'dark':
                    return DARK_THEME.COLOR;

                default:
                    return LIGHT_THEME.COLOR;
            }
        },

        backgroundColor() {
            switch (true) {
                case !!this.mode:
                    return this.mode === 'light' ? LIGHT_THEME.BACKGROUND_COLOR : DARK_THEME.BACKGROUND_COLOR;

                case this.appTheme === 'dark':
                    return DARK_THEME.BACKGROUND_COLOR;

                default:
                    return LIGHT_THEME.BACKGROUND_COLOR;
            }
        },
    },
};
</script>

<style lang="scss">
.loading-component {
    @extend %fill;
    z-index: 999999;

    &__content {
        @extend %center-middle;
    }

    &__icon {
        margin: 0;
    }
}
</style>
